import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { BASE_SP_V2_PATH } from "../constants"
import { getServiceErrorMessage } from "../../helpers"
import { Context, Transitions } from "../../types"

export const getSPV2SubjectsStudyPlansTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    id: "getStudyPlansBySubject",
    src: "getStudyPlansBySubject",
    onDone: {
      target: `${BASE_SP_V2_PATH}.idle`,
      actions: assign<Context, DoneInvokeEvent<any>>((ctx, evt) => {
        return {
          studyPlansListBySubjects: evt.data.plans
        }
      })
    },
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        loading: false,
        snackbar: (_ctx, evt) => ({
          message: getServiceErrorMessage(
            "getCurrentPlanForEachSubjectByRefScope",
            {
              errorReason: evt.data.message
            }
          ),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
